<div id="wrapper">
  <!-- Add loading spinner -->
  @if (loading$ | async) {
    <div class="loading-overlay">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  }

  <app-navbar />
  <div id="page-wrapper" class="gray-bg">
    <div class="row border-bottom">
      @if (showFooter) {
        <app-navtop />
      }
    </div>
    <app-page-header />
    <router-outlet />
    @if (showFooter) {
      <app-footer />
    }
  </div>
</div>

